import {
  RecaptchaServiceInterface,
  RecaptchaServiceInvokeRequest,
  RecaptchaServiceInvokeResponse,
} from '@central-products/interface-recaptcha-service';
import { loadScript } from '@central-products/script-module-loader';
import { RecaptchaServiceConfig } from './types';
import './index.scss';

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready: (callback: () => void) => void;
      };
    };
  }
}

export class RecaptchaService extends RecaptchaServiceInterface {
  private readonly config: RecaptchaServiceConfig;
  private loadScriptPromise?: Promise<void>;

  constructor(config: RecaptchaServiceConfig) {
    super();

    this.config = config;
  }

  public init() {
    this.loadScript();
  }

  public async invoke(payload: RecaptchaServiceInvokeRequest): Promise<RecaptchaServiceInvokeResponse> {
    return new Promise(async (resolve) => {
      try {
        const executeTimer = window.setTimeout(() => {
          resolve({ response: undefined });
        }, payload.timeout);

        await this.loadScript();

        if (!window.grecaptcha || !window.grecaptcha.enterprise || !window.grecaptcha.enterprise.ready) {
          resolve({ response: undefined });
          return;
        }

        window.grecaptcha.enterprise.ready(async () => {
          try {
            let invokeFunction = window.grecaptcha.enterprise;

            for (const path of payload.function.split('.')) {
              // @ts-ignore
              invokeFunction = invokeFunction[path];

              if (typeof invokeFunction === 'undefined') {
                resolve({ response: undefined });
                return;
              }
            }

            // @ts-ignore
            const response = await invokeFunction(this.config.siteKey, payload.options);
            window.clearTimeout(executeTimer);
            resolve({
              response,
            });
          } catch (error) {
            resolve({ response: undefined });
          }
        });
      } catch (error) {
        resolve({ response: undefined });
      }
    });
  }

  private async loadScript(): Promise<void> {
    if (!this.loadScriptPromise) {
      this.loadScriptPromise = new Promise(async (resolve) => {
        try {
          await loadScript({
            name: 'recaptcha-enterprise',
            src: `https://www.google.com/recaptcha/enterprise.js?render=${this.config.siteKey}`,
          });
        } catch (error) {}

        resolve();
      });
    }

    return this.loadScriptPromise;
  }
}
